// vuex/store.js
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

// 引入Vuex持久化插件
import createPersistedState from "vuex-persistedstate";
import permission from "./modules/permission";

/**
 * 读取./modules下的所有js文件并注册模块
 */
const requireModule = require.context('./modules', false, /\.js$/)
const modules = {}

requireModule.keys().forEach(fileName => {
  const moduleName = fileName.replace(/(\.\/|\.js)/g, '')
  modules[moduleName] = {
    ...requireModule(fileName).default
  }
})

export default new Vuex.Store({
  // 组合各个模块
  modules,
  plugins: [createPersistedState({
    storage: window.sessionStorage,
    reducer(val) {
      return {
        userLogin: val.userLogin
      }
    }
  })]
});



// WEBPACK FOOTER //
// ./src/vuex/store.js